import { extendMoment } from 'moment-range';
import moment from 'moment-timezone';

import compareStartTimes from 'lib/sortTimesAscending.util';

export function calculateRangeOfWorkingHoursWeek(openingHours, currentDate, step, procedures) {
  const closeArr = openingHours.map((e) => e.close_time).sort();
  const openArr = openingHours.map((e) => e.open_time).sort();
  const todayString = moment().format('L');
  // NOTE: In some future PR, we should gather this kind of formatting regexes in a single place as constants for reuse.
  const formatStartHours = moment(`${todayString} ${openArr[0]}`, 'MM/DD/YYYY HH:mm:ss');
  // add Formatter so moment know what to do with the input
  const formatEndHours = moment(`${todayString} ${closeArr[closeArr.length - 1]}`, 'MM/DD/YYYY HH:mm:ss');

  // add Formatter so moment know what to do with the input

  let startTime = moment(currentDate).set({
    hour: formatStartHours.get('hour'),
    minute: formatStartHours.get('minute'),
    second: formatStartHours.get('second'),
    millisecond: 0,
  });
  let endTime = moment(currentDate).set({
    hour: formatEndHours.get('hour'),
    minute: formatEndHours.get('minute'),
    second: formatEndHours.get('second'),
    millisecond: 0,
  });
  // const earliestStart = moment(startTime).subtract(12, 'hours');
  // const latestEnd = moment(endTime).add(12, 'hours');
  const earliestStart = moment(startTime);
  const latestEnd = moment(endTime);

  const currentDayProcedures = procedures
    .filter((p) => moment(p.start_time).isBefore(latestEnd) && moment(p.start_time).isAfter(earliestStart))
    .sort(compareStartTimes);
  if (currentDayProcedures.length > 0) {
    const firstProcedureTime = moment(currentDayProcedures[0].start_time);
    const lastProcedureTime = currentDayProcedures[currentDayProcedures.length - 1].start_time;
    if (moment(firstProcedureTime).isBefore(startTime)) {
      const formatFirstProcedureTime = moment(firstProcedureTime, 'hh:mm:ss');
      startTime = moment(currentDate).set({
        hour: formatFirstProcedureTime.get('hour'),
        minute: formatFirstProcedureTime.get('minute'),
        second: 0,
        millisecond: 0,
      });
    }
    if (moment(lastProcedureTime).isAfter(endTime)) {
      const formatLastProcedureTime = moment(lastProcedureTime, 'hh:mm:ss');
      endTime = moment(currentDate).set({
        hour: formatLastProcedureTime.get('hour'),
        minute: formatLastProcedureTime.get('minute'),
        second: 0,
        millisecond: 0,
      });
    }
  }

  const m = extendMoment(moment);
  const range = m.range(moment(startTime).subtract(1, 'hours'), moment(endTime).add(1, 'hours'));
  return Array.from(range.by('minutes', { step }));
}

export function generateWeekHeader(currentDate, openingHours) {
  const generateWeek = [];
  for (let i = 1; i < 8; i += 1) {
    const currentDay = moment(currentDate).weekday(i);
    const dayName = currentDay.format('ddd');
    const isOpen = openingHours.filter((day) => day.shortName === dayName.toLowerCase())[0].open;
    const day = {
      id: i,
      name: dayName,
      date: currentDay.format('D MMM'),
      wholeDate: moment(currentDate).weekday(i),
      open: isOpen,
    };
    generateWeek.push(day);
  }

  return generateWeek;
}

export const rangeHoursNoChange = (current, next) => {
  if (current.length !== next.length) return false;

  for (let i = 0; i < current.length; i += 1) {
    const c = current[i];
    const n = next[i];
    if (moment(c).toISOString() !== moment(n).toISOString()) return false;
  }

  return true;
};

export function isInWorkingRange(itemTime, openingHours) {
  let result = true;
  // We use day here as this goes straight to the JS date implementation
  let salonHour = openingHours[itemTime.day()];
  // it seems under some circumstances safari can get the above array in the wrong order
  // So double check and correct
  if (salonHour.shortName !== itemTime.format('ddd').toLowerCase()) {
    const day = openingHours.filter((o) => o.shortName === itemTime.format('ddd').toLowerCase());
    if (day.length === 1) {
      [salonHour] = day;
    }
  }

  if (salonHour && salonHour.open) {
    const openTimeH = moment(salonHour.open_time, 'HH:mm').get('hour');
    result = itemTime.get('hour') <= openTimeH;
    if (result && itemTime.get('hour') === openTimeH) {
      const openTimeM = moment(salonHour.open_time, 'HH:mm').get('minute');
      result = itemTime.get('minute') < openTimeM;
    }
    if (!result) {
      const closeTimeH = moment(salonHour.close_time, 'HH:mm').get('hour');
      result = itemTime.get('hour') >= closeTimeH;
      if (result && itemTime.get('hour') === closeTimeH) {
        const closeTimeM = moment(salonHour.close_time, 'HH:mm').get('minute');
        return itemTime.get('minute') >= closeTimeM;
      }
    }
  } else if (salonHour && !salonHour.open) {
    result = true;
  }

  return result;
}

function addToProceduresStruct(struct, procedure) {
  const m = extendMoment(moment);
  let added = false;
  let depth = 0;
  let currentLevel = struct;
  const start = m(procedure.start_time);

  while (!added) {
    let inRange = false;
    for (let i = 0; i < currentLevel.length; i += 1) {
      const level = currentLevel[i];
      if (level.timeRange.contains(start, { excludeStart: true, excludeEnd: true })) {
        currentLevel = level.children;
        depth += 1;
        inRange = true;
        break;
      }
    }
    if (!inRange) {
      const startDate = moment(procedure.start_time);
      const endTime = moment(procedure.start_time).add(moment.duration(procedure.duration).asMinutes(), 'minutes');

      const range = m.range(startDate, endTime);

      currentLevel.push({
        procedure,
        status: { depth, procedureOverlap: 'FREE' },
        timeRange: range,
        children: [],
      });
      added = true;
    }
  }
}

function getLevelData(level) {
  let resultArr = [{ procedure: level.procedure, overlapStatus: level.status }];
  if (level.children.length) {
    level.children.forEach((child) => {
      resultArr = resultArr.concat(getLevelData(child));
    });
  }

  return resultArr;
}

// Function that creates a hierarchical tree structure for the procedures that helps to find their overlapping
// When the depth and the type of overlap is calculated it is flattened back
// the flattening is done because searching in all procedures will take more time
export function calculateOverlapping(procedures) {
  const proceduresStruct = [];
  procedures.forEach((procedure) => {
    addToProceduresStruct(proceduresStruct, procedure);
  });

  const flattenHierTreeStruct = (struct) => {
    let result = [];
    struct.forEach((level) => {
      result = result.concat(getLevelData(level));
    });

    return result;
  };

  return flattenHierTreeStruct(proceduresStruct);
}

const MIN_DURATION = 15 * 60 * 1000;

export const resizeProcedureDuration = ({ procedure, endTime }) => {
  if (!procedure) {
    return procedure;
  }

  const { start_time: startTime, is_custom_duration: alreadyHadCustomDuration } = procedure;

  const diff = moment(endTime).diff(moment(startTime));
  const newDuration = moment.duration(diff < MIN_DURATION ? MIN_DURATION : diff).toISOString();

  // if the procedure was already marked to have custom duration, don't re-validate that
  // there isn't enough info here (the default duration) to be able to revert it to false
  if (alreadyHadCustomDuration) {
    return {
      ...procedure,
      is_custom_duration: true,
      duration: newDuration,
    };
  }

  // the check is done if a change in value really did happen i.e. old and new durations are not the same
  return {
    ...procedure,
    is_custom_duration: moment.duration(procedure.duration).toISOString() !== newDuration,
    duration: newDuration,
  };
};
